import { render, staticRenderFns } from "./SocialReportingHelpModal.vue?vue&type=template&id=1d6a09ce&scoped=true&"
import script from "./SocialReportingHelpModal.vue?vue&type=script&lang=js&"
export * from "./SocialReportingHelpModal.vue?vue&type=script&lang=js&"
import style0 from "./SocialReportingHelpModal.vue?vue&type=style&index=0&id=1d6a09ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d6a09ce",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VCardText})
